var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "5px",
    viewBox: "0 0 7 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3B9F39F3-5E57-4385-8368-63FD52C33277") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00b_rejestracja4",
    transform: "translate(-674.000000, -794.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(669.000000, 572.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inputs/checkbox/checkbox+text-copy-21",
    transform: "translate(0.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inputs/checkbox/off",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1097565,6.15173794 C10.9250456,5.95697232 10.6171003,5.94839419 10.42203,6.13357388 L7.3163034,9.07894107 L5.83495965,7.55801138 C5.64734246,7.36551919 5.33972527,7.36130044 5.14706902,7.54894107 C4.95457684,7.73639419 4.95052215,8.0443395 5.13797527,8.23683169 L6.95419402,10.1015426 C7.04937371,10.1993239 7.1758659,10.2486129 7.30268621,10.2486129 C7.42301434,10.2486129 7.54334246,10.2041754 7.63756121,10.1151598 L11.0916159,6.83948794 C11.2865221,6.65461294 11.2947721,6.34666763 11.1097565,6.15173794 Z",
    id: "checkmark"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.aec8365b.svg";
export { ForwardRef as ReactComponent };